/* eslint-disable react/jsx-boolean-value */
/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  consistent-return  */
/* eslint-disable import/order */

import { Typography, message } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { checkStatus, getAllCardholders, resetCardholders } from '~/api/cardholder';
import { useGetContactsApi } from '~/controllers/contacts';
import { Collapse } from '~/components';
import Form from '~/components/WizardForm';
import colors from '~/constants/colors';
import { useGetDraft, useSaveDraft } from '~/controllers/draft';
import { useFieldMap } from '~/controllers/pricing';
import { useGetApplication, useSubmitStep } from '~/controllers/wizard';
import { useAmendment } from '~/controllers/amendment';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { CardIcon, VCardIcon } from '~/img';
import {
  setApplicationStage,
  setConfirmValue,
  setHierarchyErr,
  setHierarchylevels,
  setLeafNodesHaveNocardholders,
  setShowStatusAlert,
} from '~/slices/state';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { CustomPricing, ProductMap } from '~/types/CustomPricing';
import { Draft } from '~/types/Draft';
import { ServicesKeys } from '~/types/Services';
import buildNamePath from '~/utils/buildNamePath';

import TreeChildren from './TreeChildren';
import Guidance from './components/Guidance';
import { getLeafNodes, getListReadyForGet, getListReadyForPost, listToTree } from './components/utils';

type PanelErrorType = Record<ServicesKeys, boolean>;
const initialPanelErrorState: PanelErrorType = {
  nGeniusPos: false,
  eCommerce: false,
  nGeniusGo: false,
  CORPORATE_EXECUTIVE_CARD: false,
  DIGITAL_BUSINESS_PAYMENT: false,
  DIGITAL_TRAVEL_PAYMENT: false,
  BUSINESS_CARD: false,
};

export type ServicesDraft = {
  services: Partial<ApplicationPayload['cardOrderDetails']>;
  productMap?: ProductMap;
  additionalConfigurations?: CustomPricing;
  productMapTemp?: any; // Prop to store some temporary data
  isAgreeWithServicesTermsAndConditions: boolean;
};

export const physicalCards = ['CORPORATE_EXECUTIVE_CARD', 'BUSINESS_CARD'];

const CardOrderDetails: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: contactsInfo } = useGetContactsApi();

  const applicationQuery = useGetApplication();
  const { isAmendment, isProductLocked, lockedProductKeys } = useAmendment();
  const servicesDetailsData = applicationQuery?.data?.payload?.servicesDetails;
  const applicationStage: any = applicationQuery?.data?.errorKeys?.length ? 'error' : 'fillApplication';

  const globeState = useSelector((state: any) => state?.state);
  const { confirmValue } = globeState;
  const [productsList, setProductsList] = useState<any>({
    CORPORATE_EXECUTIVE_CARD: [],
    DIGITAL_TRAVEL_PAYMENT: [],
    DIGITAL_BUSINESS_PAYMENT: [],
    BUSINESS_CARD: [],
  });
  const [treeData, setTreeData] = useState<any>({
    CORPORATE_EXECUTIVE_CARD: [],
    DIGITAL_TRAVEL_PAYMENT: [],
    DIGITAL_BUSINESS_PAYMENT: [],
    BUSINESS_CARD: [],
  });
  const [calldraft, setCalldraft] = useState<any>(false);
  const [firstRerender, setFirstRerender] = useState<any>(true);

  const ref = useRefScrollTo();
  const { data: selectedProducts }: any = useGetDraft('services');
  const selectedServicesFromDraft = selectedProducts?.cardOrderDetails?.products?.filter((item: any) => {
    return item?.enabled;
  });

  const selectedServicesFromApp = servicesDetailsData?.products?.filter((item: any) => {
    return item?.enabled;
  });
  const predefinedServicesWithWierarchylevel = !selectedServicesFromApp?.length
    ? selectedServicesFromDraft
    : selectedServicesFromApp;
  const levelsSelected: any = servicesDetailsData?.levelsSelected || ['company', 'cardholder'];

  const fieldMap = useFieldMap();
  const [form] = Form.useForm();
  const { data } = useGetDraft<Draft<'cardOrderDetails'>>();

  /// onFinish
  const submitMutation = useSubmitStep();

  async function onFinishCardOrderDetails(productsListProps: any) {
    const result = parseBeforeSubmitHandler(productsListProps);
    await submitMutation.mutateAsync({ stepData: result });
    return Promise.resolve();
  }

  const enabledProductIds: string[] = useMemo(
    () => [...(predefinedServicesWithWierarchylevel?.map((item: any) => item?.id) ?? []), ...lockedProductKeys],
    [JSON.stringify(predefinedServicesWithWierarchylevel), JSON.stringify(lockedProductKeys)],
  );

  function keepEnabledProducts(list: any) {
    return Object.entries(list || {}).reduce((acc: any, [key, value]) => {
      acc[key] = enabledProductIds.includes(key) ? value : [];
      return acc;
    }, {});
  }

  useEffect(() => {
    if (data && !confirmValue) {
      const iterateProductList = getListReadyForGet(data?.cardOrderDetails, undefined, lockedProductKeys);
      setProductsList(keepEnabledProducts(iterateProductList));
    } else if (applicationQuery?.data?.payload?.cardOrderDetails?.hierarchyLists) {
      const applicationHierarchy = applicationQuery?.data?.payload?.cardOrderDetails.hierarchyLists;
      const applicationList = getListReadyForGet(applicationHierarchy, undefined, lockedProductKeys);
      setProductsList(keepEnabledProducts(applicationList));
    }
    dispatch(setHierarchylevels(levelsSelected));
  }, [data, enabledProductIds]);

  function parseBeforeSubmitHandler(values: any) {
    const results = listToTree(values);
    const iterateProductListWithouCompnents = getListReadyForPost(values);
    return {
      cardOrderDetails: {
        hierarchyLevels: results,
        hierarchyLists: iterateProductListWithouCompnents,
      },
      // services: {},
    };
  }

  async function resetCardholdersHandler(unselectedCard: string) {
    const resetResponse = await resetCardholders(unselectedCard);
  }
  const draftMutation = useSaveDraft();

  useEffect(() => {
    if (calldraft && contactsInfo) {
      getAllCardholders().then((cardholdersInfo: any) => {
        const iterateProductListWithouCompnents = getListReadyForPost(productsList, cardholdersInfo, contactsInfo);
        draftMutation.mutate({
          stepData: {
            cardOrderDetails: iterateProductListWithouCompnents,
          },
        });
      });
    }
    dispatch(setShowStatusAlert<any>(false));
  }, [JSON.stringify(productsList), contactsInfo, calldraft]);

  async function beforeFinishHandler() {
    let data = false;
    try {
      data = await checkStatus();
    } catch (error: any) {
      message.error(error.message);
    }
    const leafNodes: any = getLeafNodes(productsList);
    const obj: any = {};
    predefinedServicesWithWierarchylevel?.map((item: any) => {
      if (item?.enabled && !isProductLocked(item.id)) {
        obj[item.id] = leafNodes[item.id];
      }
      return item;
    });
    const checkLeafhasNocardholder = Object.values(obj || {}).some((item: any) => !!item.length);
    if (checkLeafhasNocardholder) {
      dispatch(setLeafNodesHaveNocardholders(leafNodes));
    } else {
      dispatch(setLeafNodesHaveNocardholders(undefined));
    }
    if (!data) {
      dispatch(setShowStatusAlert<any>(true));
    }
    if (data && !checkLeafhasNocardholder) {
      setCalldraft(true);
    }

    return data && !checkLeafhasNocardholder;
  }
  useEffect(() => {
    if (confirmValue) {
      setProductsList({
        CORPORATE_EXECUTIVE_CARD: [],
        DIGITAL_TRAVEL_PAYMENT: [],
        DIGITAL_BUSINESS_PAYMENT: [],
        BUSINESS_CARD: [],
      });
      dispatch(setConfirmValue<any>(false));
      resetCardholdersHandler('businessCardholder,cardholder');
    }
    dispatch(setApplicationStage(applicationStage));
    dispatch(setHierarchyErr<any>(false));
    /// remove unselected products
    const enabledProducts = predefinedServicesWithWierarchylevel?.map((item: any) => item?.id);
    const missingProducts = Object?.keys(productsList || {})
      ?.filter((item: any) => !enabledProducts?.find((ele: any) => ele === item))
      ?.reduce((obj: any, item: any) => {
        if (!obj[item]) {
          obj[item] = [];
        }
        return obj;
      }, {});
    if (missingProducts?.CORPORATE_EXECUTIVE_CARD) {
      resetCardholdersHandler('cardholder');
    }
    if (missingProducts?.BUSINESS_CARD) {
      resetCardholdersHandler('businessCardholder');
    }
    setProductsList((prev: any) => {
      const alreadySelectedProduct: any = Object?.entries(prev || {})?.find(([key, value]: any) => value?.length > 1);
      const [productKeyCopy, productValue] = alreadySelectedProduct || [];
      const valuesWithoutCardholder = productValue?.filter((item: any) => item?.type !== 'cardholder');
      if (alreadySelectedProduct) {
        const reEvaluteProducts = Object.entries(prev || {})?.reduce((acc: any, curr) => {
          const [keycurr, value]: any = curr;

          if (value?.find((ele: any) => ele?.type === 'cardholder')) {
            acc[keycurr] = value;
          } else {
            const genereatedNewVaue = valuesWithoutCardholder?.map((item: any) => {
              return {
                ...item,
                parentId: item?.parentId?.replaceAll(productKeyCopy, keycurr) || null,
                uniqueId: item?.uniqueId?.replaceAll(productKeyCopy, keycurr),
                key: item?.key?.replaceAll(productKeyCopy, keycurr),
              };
            });
            acc[keycurr] = genereatedNewVaue;
          }

          return acc;
        }, {});
        return { ...prev, ...reEvaluteProducts, ...missingProducts };
      }

      return { ...prev, ...missingProducts };
    });
  }, []);

  useEffect(() => {
    if (firstRerender) {
      const productListValues = Object?.values(productsList || {})?.flat();
      if (productListValues?.length && !productListValues?.find((item: any) => item?.type === 'cardholder')) {
        message.warning('No Cardholder Found');
        setFirstRerender(false);
      }
    }
  }, [productsList]);

  if (!applicationQuery.data) return null;
  if (!fieldMap) return null;
  return (
    <Container ref={ref}>
      <Form<Draft<'cardOrderDetails'>>
        form={form}
        stepKey="cardOrderDetails"
        name="cardOrderDetails"
        onFinish={async () => {
          const response = await beforeFinishHandler();

          dispatch(setHierarchyErr<any>(response));
          if (!response) {
            return null;
          }

          getAllCardholders().then((cardholdersInfo: any) => {
            const iterateProductListWithouCompnents = getListReadyForPost(productsList, cardholdersInfo, contactsInfo);
            setTimeout(
              () => {
                onFinishCardOrderDetails(iterateProductListWithouCompnents);
              },
              response ? 1400 : 0,
            );
          });
        }}
      >
        <div className="sectionHeader">
          <Typography.Title level={1}>{t('Hierarchy and Card Details')}</Typography.Title>
          <Typography.Paragraph className="SelectServicesInitial-Paragraph">
            {t('Define your company hierarchy.')}
          </Typography.Paragraph>
        </div>
        <Guidance hierarchyLevels={levelsSelected} />
        <div className="productsParents">
          {predefinedServicesWithWierarchylevel?.map((item: any) => {
            const isItPhysical = physicalCards.includes(item?.id);
            const defaultTreeKeys = productsList[item.id]?.map((item: any) => item.key);
            const productLocked = isAmendment && isProductLocked(item.id);
            return (
              <>
                <ProductChildContainer type={item.id}>
                  <Collapse ghost className="ServicesForm-Collapse" defaultActiveKey={productLocked ? [] : [item.id]}>
                    <Collapse.Panel
                      id="cardCollapseWidth"
                      key={item.id}
                      header={t(item?.id)}
                      error={initialPanelErrorState[item.id as keyof PanelErrorType]}
                      collapsible={productLocked ? 'disabled' : 'header'}
                    >
                      <BoxContainer colors={colors}>
                        <div
                          style={isItPhysical ? { backgroundColor: colors?.grey[1100] } : {}}
                          className="cardBoxContainer"
                        >
                          {isItPhysical ? (
                            <CardIcon style={{ fontSize: 40, backgroundColor: colors?.grey[1100] }} />
                          ) : (
                            <VCardIcon style={{ fontSize: 80, marginTop: '-25px', marginRight: '25px' }} />
                          )}
                        </div>
                      </BoxContainer>
                      <TreeChildren
                        selectedProducts={predefinedServicesWithWierarchylevel}
                        applicationQuery={applicationQuery}
                        setCalldraft={setCalldraft}
                        setTreeData={setTreeData}
                        treeData={treeData[item?.id]}
                        setProductsList={setProductsList}
                        productList={productsList[item?.id]}
                        productData={productsList}
                        predefiendHierarchy={levelsSelected}
                        productKey={item.id}
                        defaultKeys={defaultTreeKeys}
                        allProductsLists={productsList}
                        productLocked={productLocked}
                      />
                    </Collapse.Panel>
                  </Collapse>
                </ProductChildContainer>
              </>
            );
          })}
        </div>
      </Form>
    </Container>
  );
};
const n = buildNamePath('cardOrderDetails');
const BoxContainer = styled.div<any>`
  margin-bottom: 40px;
  .cardBoxContainer {
    position: absolute;
    top: 25px;
    right: 18px;
    /* background-color: ${({ colors }) => colors?.grey[1100]}; */
    margin-left: 20px;
    padding: 5px 20px 0 20px;
    border-radius: 8px;
    width: 80px;
  }
`;
const Container = styled.div`
  margin-bottom: 100px;
  .sectionHeader {
    margin-top: 40px;
  }
  .productsParents {
    display: flex;
    flex-direction: column;
  }
`;
const ProductChildContainer = styled.div<any>`
  order: ${({ type }) => {
    if (type === 'BUSINESS_CARD') {
      return 1;
    }
    if (type === 'CORPORATE_EXECUTIVE_CARD') {
      return 2;
    }
    if (type === 'DIGITAL_BUSINESS_PAYMENT') {
      return 3;
    }
    if (type === 'DIGITAL_TRAVEL_PAYMENT') {
      return 4;
    }
    return 0;
  }};
  position: relative;
  border: solid 1px #e2e2e3;
  border-radius: 10px;
  padding: 16px;
  margin-top: 48px;
  .Collapse-Icon {
    vertical-align: 2.5px !important;
  }
  .ant-collapse-header {
    font-size: 24px;
    /* padding: 16px 0; */
    text-transform: unset;
  }
  .ant-collapse-content-box {
    /* padding: 0 0 40px 0 !important; */
  }
`;

export default CardOrderDetails;
